import './style.sass';
import React from 'react';
import { ReactSVG } from 'react-svg';
import closeIcon from 'assets/img/icons/close-icon.svg';
import { Button } from '../Button';

type Props = {
    title: string,
    desc: string,
    cancelBtnText: string,
    approveBtnText: string,
    onClickCloseBtn: () => void,
    onClickApprove: () => void,
    isLoading?: boolean,
};

export const ApproveWindow = ({
    title,
    desc,
    cancelBtnText,
    approveBtnText,
    isLoading,
    onClickCloseBtn,
    onClickApprove,
}: Props) => {
    return (
        <div className="approve-window" onClick={(e) => e.stopPropagation()}>
            <div className="approve-window__close-btn" onClick={onClickCloseBtn}>
                <ReactSVG src={closeIcon}/>
            </div>

            <div className="approve-window__text-block">
                <h1 className="title-h1 approve-window__title">{title}</h1>

                <p className="p1-regular approve-window__desc">{desc}</p>
            </div>

            <div className="approve-window__btn-block">
                <Button
                    onClick={onClickCloseBtn}
                    size="big"
                    text={cancelBtnText}
                    colorType="primary-light"
                    className="cancel-btn"
                />

                <Button
                    onClick={onClickApprove}
                    size="big"
                    text={approveBtnText}
                    className="approve-btn"
                    isLoading={isLoading}
                />
            </div>
        </div>
    );
};
